import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import PretendardText from "../../atoms/text/pretendardText";
import MainInput from "../../atoms/input/mainInput";
import Checkbox from "../../atoms/input/checkbox";
import ImgInputIcon from "../../atoms/input/imgInputIcon";
import RedBtn from "../../atoms/button/redBtn";
import ImgPreviewIcon from "../../molecules/imgPreviewIcon";
import SubSideBarItem from "../../molecules/subSideBarItem";
import Popup from "../../molecules/popup";
import { fileUrl } from "../../../api/api";
import BoardApi from "../../../api/board.api";
import FileApi from "../../../api/file.api";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import PopupOverLay from "../PopupOverlay";
import Modal from "../Modal";

const CategoryManagePopup = ({
  popupOpen,
  setPopupOpen,
  getMainCategoryList,
  mainCategoryList,
  setMainCategoryList,
}) => {
  // ---------- 이미지 관련 --------- //
  const [activationStatus, setActivationStatus] = useState(true);
  const [activationSubStatus, setActivationSubStatus] = useState(true);
  const [selectedPopupMainCategory, setSelectedPopupMainCategory] = useState({
    id: 0,
    title: "",
    activation: true,
    file: "",
    fileUrl: "",
    fileName: "",
    activeFile: "",
    activeFileUrl: "",
    activeFileName: "",
  });
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [selectedPopupSubCategory, setSelectedPopupSubCategory] = useState({
    id: -1,
    title: "",
    activation: true,
  });

  // 카테고리 삭제하기
  const [mainCategoryDeleteModalOpen, setMainCategoryDeleteModalOpen] =
    useState(false);

  useEffect(() => {
    setActivationStatus(true);
    setActivationSubStatus(true);

    setSelectedPopupMainCategory({
      ...selectedPopupMainCategory,
      id: 0,
      title: "",
      activation: true,
    });
    setSelectedPopupSubCategory({
      id: -1,
      title: "",
      activation: true,
    });
  }, [popupOpen]);

  // 상위 카테고리 추가하기
  const createMainCategory = async () => {
    try {
      if (selectedPopupMainCategory.title === "") {
        toast("카테고리명을 입력해주세요.");
        return;
      } else if (selectedPopupMainCategory.file === "") {
        toast("아이콘 이미지를 업로드해주세요.");
        return;
      } else if (selectedPopupMainCategory.activeFile === "") {
        toast("활성화 아이콘 이미지를 업로드해주세요.");
        return;
      }

      const iconImageResponse = await FileApi.fileUpload(
        selectedPopupMainCategory.file,
        "admin/community"
      );
      const activeIconImageResponse = await FileApi.fileUpload(
        selectedPopupMainCategory.activeFile,
        "admin/community"
      );

      const data = {
        title: selectedPopupMainCategory.title,
        activation: activationStatus,
        imageOriginFileName: selectedPopupMainCategory.fileName,
        imageServerFileName: iconImageResponse.data.data.serverFileName,
        imageActiveOriginFileName: selectedPopupMainCategory.activeFileName,
        imageActiveServerFileName:
          activeIconImageResponse.data.data.serverFileName,
      };

      await BoardApi.createMain(data);

      setSelectedPopupMainCategory({
        id: 0,
        title: "",
        activation: true,
        file: null,
        fileUrl: null,
        fileName: null,
        activeFile: null,
        activeFileUrl: null,
        activeFileName: null,
      });
      toast(toastMsg.create);
      getMainCategoryList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 상위 카테고리 수정하기
  const updateMainCategory = async () => {
    try {
      if (
        selectedPopupMainCategory.id !== 0 &&
        selectedPopupMainCategory.title === ""
      ) {
        toast("카테고리명을 입력해주세요.");
        return;
      } else if (!selectedPopupMainCategory.fileUrl) {
        toast("아이콘 이미지를 업로드해주세요.");
        return;
      } else if (!selectedPopupMainCategory.activeFileUrl) {
        toast("활성화 아이콘 이미지를 업로드해주세요.");
        return;
      }

      if (
        selectedPopupMainCategory.file ||
        selectedPopupMainCategory.activeFile
      ) {
        let iconImageResponse = null;
        let activeIconImageResponse = null;

        if (selectedPopupMainCategory.file) {
          iconImageResponse = await FileApi.fileUpload(
            selectedPopupMainCategory.file,
            "admin/community"
          );
        }

        if (selectedPopupMainCategory.activeFile) {
          activeIconImageResponse = await FileApi.fileUpload(
            selectedPopupMainCategory.activeFile,
            "admin/community"
          );
        }

        const updatedMainCategoryList = mainCategoryList.map((category) => {
          if (category.id === selectedPopupMainCategory.id) {
            return {
              id: selectedPopupMainCategory.id,
              title: selectedPopupMainCategory.title,
              activation: selectedPopupMainCategory.activation,
              imageOriginFileName: selectedPopupMainCategory.fileName
                ? selectedPopupMainCategory.fileName
                : category.imageOriginFileName,
              imageServerFileName: selectedPopupMainCategory.file
                ? iconImageResponse.data.data.serverFileName
                : category.imageServerFileName,
              imageActiveOriginFileName:
                selectedPopupMainCategory.activeFileName
                  ? selectedPopupMainCategory.activeFileName
                  : category.imageActiveOriginFileName,
              imageActiveServerFileName: selectedPopupMainCategory.activeFile
                ? activeIconImageResponse.data.data.serverFileName
                : category.imageActiveServerFileName,
            };
          }

          return category;
        });

        const data = {
          boardCategoryList: updatedMainCategoryList,
        };

        await BoardApi.updateMain(data);
      } else {
        const updatedMainCategoryList = mainCategoryList.map((category) => {
          if (category.id === selectedPopupMainCategory.id) {
            return {
              id: selectedPopupMainCategory.id,
              title: selectedPopupMainCategory.title,
              activation: selectedPopupMainCategory.activation,
              imageOriginFileName: category.imageOriginFileName,
              imageServerFileName: category.imageServerFileName,
              imageActiveOriginFileName: category.imageActiveOriginFileName,
              imageActiveServerFileName: category.imageActiveServerFileName,
            };
          }

          return category;
        });

        const data = {
          boardCategoryList: updatedMainCategoryList,
        };

        await BoardApi.updateMain(data);
      }

      setSelectedPopupMainCategory({
        id: 0,
        title: "",
        activation: true,
        file: null,
        fileUrl: null,
        fileName: null,
        activeFile: null,
        activeFileUrl: null,
        activeFileName: null,
      });
      toast(toastMsg.update);
      getMainCategoryList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const inputFile = (e, type) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    if (type === "default") {
      fileReader.onload = (value) => {
        setSelectedPopupMainCategory({
          ...selectedPopupMainCategory,
          file: file,
          fileUrl: value.target.result,
          fileName: file.name,
        });
      };
    } else if (type === "active") {
      fileReader.onload = (value) => {
        setSelectedPopupMainCategory({
          ...selectedPopupMainCategory,
          activeFile: file,
          activeFileUrl: value.target.result,
          activeFileName: file.name,
        });
      };
    }

    e.target.value = "";
  };

  const deleteFile = (type) => {
    if (type === "default") {
      setSelectedPopupMainCategory({
        ...selectedPopupMainCategory,
        file: null,
        fileUrl: null,
        fileName: null,
      });
    } else if (type === "active") {
      setSelectedPopupMainCategory({
        ...selectedPopupMainCategory,
        activeFile: null,
        activeFileUrl: null,
        activeFileName: null,
      });
    }
  };

  // 선택된 카테고리 및 아이콘 파일 초기화
  const initializeCategory = () => {
    setSelectedPopupMainCategory({
      id: 0,
      title: "",
      activation: true,
      file: null,
      fileUrl: null,
      fileName: null,
      activeFile: null,
      activeFileUrl: null,
      activeFileName: null,
    });

    setSelectedPopupSubCategory({
      id: -1,
      title: "",
      activation: true,
    });
  };

  // 상위 카테고리 드래그 앤 드롭
  const handleDragAndDrop = async (result) => {
    const { destination, source } = result;

    // 드래그가 취소된 경우
    if (!destination) return;
    if (destination.index === 0 || destination.index === 1) return;
    if (destination.index === mainCategoryList.length - 1) return;

    // 기존 배열을 복사
    const updatedList = Array.from(mainCategoryList);

    // 드래그된 요소를 배열에서 제거하고 새로운 위치에 삽입
    const [reorderedItem] = updatedList.splice(source.index, 1);
    updatedList.splice(destination.index, 0, reorderedItem);

    setMainCategoryList(updatedList);

    // 상태 업데이트
    const data = {
      boardCategoryList: updatedList,
    };

    await BoardApi.updateMain(data);

    getMainCategoryList();
  };

  // 하위 카테고리 드래그 앤 드롭
  const handleSubDragAndDrop = async (result) => {
    const { destination, source } = result;

    // 드래그가 취소된 경우
    if (!destination) return;

    // 기존 배열을 복사
    const updatedList = Array.from(subCategoryList);

    // 드래그된 요소를 배열에서 제거하고 새로운 위치에 삽입
    const [reorderedItem] = updatedList.splice(source.index, 1);
    updatedList.splice(destination.index, 0, reorderedItem);

    setSubCategoryList(updatedList);

    // 상태 업데이트
    const data = {
      boardSubCategoryList: updatedList,
    };

    await BoardApi.updateSub(data);

    getMainCategoryList();
  };

  // 하위 카테고리 추가하기
  const createSubCategory = async () => {
    try {
      if (selectedPopupMainCategory.id === 0) {
        toast("상위 카테고리를 선택해주세요.");
        return;
      }

      if (selectedPopupSubCategory.title === "") {
        toast("카테고리명을 입력해주세요.");
        return;
      }

      const data = {
        boardCategoryId: selectedPopupMainCategory.id,
        title: selectedPopupSubCategory.title,
        activation: activationStatus,
      };

      await BoardApi.createSub(data);

      toast(toastMsg.create);
      await getMainCategoryList();
      setSelectedPopupSubCategory({
        id: -1,
        title: "",
        activation: true,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // 하위 카테고리 수정하기
  const updateSubCategory = async () => {
    try {
      if (
        selectedPopupSubCategory.id !== 0 &&
        selectedPopupSubCategory.title === ""
      ) {
        toast("카테고리명을 입력해주세요.");
        return;
      }

      const updatedSubCategoryList = subCategoryList.map((category) => {
        if (category.id === selectedPopupSubCategory.id) {
          return {
            id: selectedPopupSubCategory.id,
            title: selectedPopupSubCategory.title,
            activation: selectedPopupSubCategory.activation,
          };
        }

        return category;
      });

      const data = {
        boardSubCategoryList: updatedSubCategoryList,
      };

      await BoardApi.updateSub(data);

      toast(toastMsg.update);
      await getMainCategoryList();
      setSelectedPopupSubCategory({
        id: -1,
        title: "",
        activation: true,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const mainCategoryDeleteHandler = async () => {
    try {
      await BoardApi.deleteMain(selectedPopupMainCategory.id);
      toast(toastMsg.delete);

      setSelectedPopupSubCategory({
        id: -1,
        title: "",
        activation: true,
      });

      setMainCategoryDeleteModalOpen(false);
      setSelectedPopupSubCategory({
        id: -1,
        title: "",
        activation: true,
      });
      await getMainCategoryList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const subCategoryDeleteHandler = async () => {
    try {
      await BoardApi.deleteSub(selectedPopupSubCategory.id);
      toast(toastMsg.delete);

      setSelectedPopupSubCategory({
        id: -1,
        title: "",
        activation: true,
      });
      setMainCategoryDeleteModalOpen(false);
      setSelectedPopupSubCategory({
        id: -1,
        title: "",
        activation: true,
      });
      await getMainCategoryList();
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    const subCategoryListTemp = mainCategoryList.find(
      (mainCategory) => mainCategory.id === selectedPopupMainCategory.id
    );

    if (
      subCategoryListTemp &&
      subCategoryListTemp?.boardSubCategoryList.length > 0
    ) {
      setSubCategoryList(subCategoryListTemp.boardSubCategoryList);
    }
  }, [mainCategoryList]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PopupOverLay
        isOpen={true}
        onClick={() => {
          setPopupOpen(false);
        }}
      >
        <Popup
          style={{
            width: 880,
          }}
          headerTitle="카테고리 관리"
          footerBtnText="저장하기"
          onClick={() => {
            setPopupOpen(false);
          }}
          footerBtnHandler={() => {
            if (selectedPopupSubCategory.id === -1) {
              if (selectedPopupMainCategory.id === 0) {
                createMainCategory();
              } else {
                updateMainCategory();
              }
            } else {
              if (selectedPopupSubCategory.id === 0) {
                createSubCategory();
              } else {
                updateSubCategory();
              }
            }
          }}
        >
          <div
            style={{
              width: "fit-content",
              height: "fit-content",
              margin: "16px 30px",
              display: "flex",
            }}
          >
            {/* 상위 카테고리 관리 팝업 좌측 영역 */}
            <div
              className="custom-scrollbar"
              style={{
                width: "210px",
                height: "100%",
                maxHeight: "433px",
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
              }}
            >
              <DragDropContext onDragEnd={handleDragAndDrop}>
                <Droppable droppableId="mainCategories">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {mainCategoryList.map((item, index) => {
                        return (
                          <Draggable
                            key={item.id}
                            draggableId={String(item.id)}
                            index={index}
                            isDragDisabled={
                              item.id !== 1 && item.id !== 2 && item.id !== 7
                                ? false
                                : true
                            }
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <SubSideBarItem
                                  selected={
                                    selectedPopupMainCategory.id === item.id
                                  }
                                  move={
                                    item.id !== 1 &&
                                    item.id !== 2 &&
                                    item.id !== 7
                                      ? true
                                      : false
                                  }
                                  dropdown={false}
                                  isRotated={item.popupDropdownOpen}
                                  dropdownHandler={() => {
                                    setMainCategoryList(
                                      mainCategoryList.map((category) => {
                                        if (category.id === item.id) {
                                          return {
                                            ...category,
                                            popupDropdownOpen:
                                              !category.popupDropdownOpen,
                                          };
                                        }

                                        return category;
                                      })
                                    );
                                  }}
                                  onClick={() => {
                                    const imageServerFileName =
                                      mainCategoryList.find(
                                        (mainCategory) =>
                                          mainCategory.id === item.id
                                      ).imageServerFileName;

                                    const activeImageServerFileName =
                                      mainCategoryList.find(
                                        (mainCategory) =>
                                          mainCategory.id === item.id
                                      ).imageActiveServerFileName;

                                    setSelectedPopupMainCategory({
                                      id: item.id,
                                      title: item.title,
                                      activation: item.activation,
                                      file: null,
                                      fileUrl: `${
                                        imageServerFileName
                                          ? `${fileUrl}/${imageServerFileName}`
                                          : ""
                                      }`,
                                      fileName: null,
                                      activeFile: null,
                                      activeFileUrl: `${
                                        activeImageServerFileName
                                          ? `${fileUrl}/${activeImageServerFileName}`
                                          : ""
                                      }`,
                                      activeFileName: null,
                                    });
                                    setSelectedPopupSubCategory({
                                      id: -1,
                                      title: "",
                                      activation: true,
                                    });
                                    const subCategoryListTemp =
                                      mainCategoryList.find(
                                        (mainCategory) =>
                                          mainCategory.id === item.id
                                      ).boardSubCategoryList;

                                    setSubCategoryList(subCategoryListTemp);
                                  }}
                                >
                                  {item.title}
                                </SubSideBarItem>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

              <SubSideBarItem
                icon="plus"
                selected={selectedPopupMainCategory.id === 0}
                onClick={initializeCategory}
              >
                상위 카테고리 추가하기
              </SubSideBarItem>
            </div>

            {/* 하위 카테고리 관리 팝업 좌측 영역 */}
            {[0, 1, 2, 7].includes(selectedPopupMainCategory.id) ? null : (
              <div
                className="custom-scrollbar"
                style={{
                  width: "210px",
                  height: "100%",
                  maxHeight: "433px",
                  display: "flex",
                  flexDirection: "column",
                  overflowY: "auto",
                }}
              >
                <DragDropContext onDragEnd={handleSubDragAndDrop}>
                  <Droppable droppableId="subCategories">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {subCategoryList.map((item, index) => {
                          return (
                            <Draggable
                              key={item.id}
                              draggableId={String(item.id)}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <SubSideBarItem
                                    selected={
                                      selectedPopupSubCategory.id === item.id
                                    }
                                    move={true}
                                    dropdown={false}
                                    dropdownHandler={() => {}}
                                    onClick={() => {
                                      setSelectedPopupSubCategory({
                                        id: item.id,
                                        title: item.title,
                                        activation: item.activation,
                                      });
                                    }}
                                  >
                                    {item.title}
                                  </SubSideBarItem>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                <SubSideBarItem
                  icon="plus"
                  selected={selectedPopupSubCategory.id === 0}
                  onClick={() => {
                    setSelectedPopupSubCategory({
                      id: 0,
                      title: "",
                      activation: true,
                    });
                  }}
                >
                  하위카테고리 추가하기
                </SubSideBarItem>
              </div>
            )}

            {/* 가운데 구분선 */}
            <span
              style={{
                width: "1px",
                height: "399px",
                marginLeft: "14px",
                marginRight: "20px",
                backgroundColor: "var(--outline1, rgba(255, 255, 255, 0.12))",
              }}
            />

            {/* 카테고리 관리 팝업 우측 영역 */}
            <div
              style={{
                width: "338px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {selectedPopupSubCategory.id === -1 ? (
                <>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "3px",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "22px",
                        color: "#aaa",
                      }}
                    >
                      카테고리명
                    </PretendardText>
                    <MainInput
                      type={"text"}
                      placeholder={"카테고리명을 입력해 주세요."}
                      style={{ width: "338px" }}
                      value={selectedPopupMainCategory.title}
                      onChange={(e) => {
                        setSelectedPopupMainCategory({
                          ...selectedPopupMainCategory,
                          title: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginTop: "10px",
                    }}
                  >
                    <Checkbox
                      checked={
                        selectedPopupMainCategory.id === 0
                          ? !activationStatus
                          : !selectedPopupMainCategory.activation
                      }
                      onChange={() => {
                        if (selectedPopupMainCategory.id === 0) {
                          setActivationStatus(!activationStatus);
                        } else {
                          setSelectedPopupMainCategory({
                            ...selectedPopupMainCategory,
                            activation: !selectedPopupMainCategory.activation,
                          });
                        }
                      }}
                    />
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        lineHeight: "21.5px",
                        color: "#aaa",
                      }}
                    >
                      홈페이지에 노출하지 않기
                    </PretendardText>
                  </div>
                  <PretendardText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "var(--text3, rgba(181, 181, 181, 0.5))",
                      marginTop: "5px",
                    }}
                  >
                    고객들이 보는 페이지에 목록이 노출되지 않습니다
                  </PretendardText>

                  {/* 아이콘 */}
                  <div
                    style={{
                      marginTop: 24,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "16px",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "22px",
                        color: "#aaa",
                      }}
                    >
                      아이콘
                    </PretendardText>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {selectedPopupMainCategory.fileUrl && (
                        <ImgPreviewIcon
                          fileUrl={selectedPopupMainCategory.fileUrl}
                        />
                      )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        {!selectedPopupMainCategory.fileUrl && (
                          <ImgInputIcon
                            id={"defaultIcon"}
                            accept={"image/png, image/jpeg, image/jpg"}
                            onChange={(e) => {
                              inputFile(e, "default");
                            }}
                          />
                        )}
                        {selectedPopupMainCategory.fileUrl && (
                          <RedBtn onClick={() => deleteFile("default")}>
                            삭제
                          </RedBtn>
                        )}
                      </div>
                      <PretendardText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "rgba(181, 181, 181, 0.5)",
                          marginTop: "5px",
                        }}
                      >
                        권장 해상도: 24x24 이상 / PNG, JPG
                      </PretendardText>
                    </div>
                  </div>

                  {/* 활성 아이콘 */}
                  <div
                    style={{
                      marginTop: 24,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "16px",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "22px",
                        color: "#aaa",
                      }}
                    >
                      활성 아이콘
                    </PretendardText>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {selectedPopupMainCategory.activeFileUrl && (
                        <ImgPreviewIcon
                          fileUrl={selectedPopupMainCategory.activeFileUrl}
                        />
                      )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        {!selectedPopupMainCategory.activeFileUrl && (
                          <ImgInputIcon
                            id={"activeIcon"}
                            accept={"image/png, image/jpeg, image/jpg"}
                            onChange={(e) => {
                              inputFile(e, "active");
                            }}
                          />
                        )}
                        {selectedPopupMainCategory.activeFileUrl && (
                          <RedBtn onClick={() => deleteFile("active")}>
                            삭제
                          </RedBtn>
                        )}
                      </div>
                      <PretendardText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "rgba(181, 181, 181, 0.5)",
                          marginTop: "5px",
                        }}
                      >
                        권장 해상도: 24x24 이상 / PNG, JPG
                      </PretendardText>
                    </div>
                  </div>

                  {selectedPopupMainCategory.id >= 8 ? (
                    <div
                      style={{
                        marginTop: 80,
                        width: "100%",
                        height: 22,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "var(--text3, rgba(181, 181, 181, 0.5))",
                          marginTop: "5px",
                          cursor: "pointer",
                          textDecorationLine: "underline",
                        }}
                        onClick={() => {
                          setMainCategoryDeleteModalOpen(true);
                        }}
                      >
                        삭제하기
                      </PretendardText>
                    </div>
                  ) : (
                    <div
                      style={{
                        height: 102,
                      }}
                    />
                  )}
                </>
              ) : (
                <>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "3px",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "22px",
                        color: "#aaa",
                      }}
                    >
                      카테고리명
                      {[6, 7, 13, 14, 15].includes(
                        selectedPopupSubCategory?.id
                      ) && (
                        <span
                          style={{
                            fontFamily: "Pretendard",
                            color: "#cf6679",
                            fontSize: 12,
                            fontWeight: 500,
                            lineHeight: "22.75px",
                          }}
                        >
                          {" "}
                          * 해당 카테고리명은 변경할 수 없습니다.
                        </span>
                      )}
                    </PretendardText>
                    <MainInput
                      type={"text"}
                      placeholder={"카테고리명을 입력해 주세요."}
                      disabled={
                        [6, 7, 13, 14, 15].includes(
                          selectedPopupSubCategory?.id
                        )
                          ? true
                          : false
                      }
                      style={{ width: "338px" }}
                      value={selectedPopupSubCategory.title}
                      onChange={(e) => {
                        setSelectedPopupSubCategory({
                          ...selectedPopupSubCategory,
                          title: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginTop: "10px",
                    }}
                  >
                    <Checkbox
                      checked={
                        selectedPopupSubCategory.id === 0
                          ? !activationSubStatus
                          : !selectedPopupSubCategory.activation
                      }
                      onChange={() => {
                        if (selectedPopupSubCategory.id === 0) {
                          setActivationSubStatus(!activationSubStatus);
                        } else {
                          setSelectedPopupSubCategory({
                            ...selectedPopupSubCategory,
                            activation: !selectedPopupSubCategory.activation,
                          });
                        }
                      }}
                    />
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        lineHeight: "21.5px",
                        color: "#aaa",
                      }}
                    >
                      홈페이지에 노출하지 않기
                    </PretendardText>
                  </div>
                  <PretendardText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "var(--text3, rgba(181, 181, 181, 0.5))",
                      marginTop: "5px",
                    }}
                  >
                    고객들이 보는 페이지에 목록이 노출되지 않습니다
                  </PretendardText>

                  <div
                    style={{
                      flex: 1,
                    }}
                  />
                  {selectedPopupSubCategory.id >= 16 && (
                    <div
                      style={{
                        marginTop: 270,
                        width: "100%",
                        height: 22,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "var(--text3, rgba(181, 181, 181, 0.5))",
                          marginTop: "5px",
                          cursor: "pointer",
                          textDecorationLine: "underline",
                        }}
                        onClick={() => {
                          setMainCategoryDeleteModalOpen(true);
                        }}
                      >
                        삭제하기
                      </PretendardText>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <ul
            style={{
              position: "absolute",
              left: 30,
              bottom: 50,
              listStyle: "disc",
              listStylePosition: "inside",
              listColor: "#aaa",
              marginRight: 0,
            }}
          >
            <li
              style={{
                fontFamily: "Pretendard",
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "22px",
                color: "var(--text3, rgba(181, 181, 181, 0.5))",
              }}
            >
              마우스 드래그로 카테고리 순서를 조정해보세요
            </li>
          </ul>
        </Popup>
      </PopupOverLay>
      {/* 메인 카테고리 삭제하기 모달 */}
      {mainCategoryDeleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setMainCategoryDeleteModalOpen}
          onClick={() => {
            if (selectedPopupSubCategory.id === -1) {
              mainCategoryDeleteHandler();
            } else {
              subCategoryDeleteHandler();
            }
          }}
        />
      )}
    </>
  );
};

export default CategoryManagePopup;
